// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"mobile-app-footer_footerContainer__21tb3"};